const APPEARANCES = ["dark", "light"];
const TOOLBAR_OVERLAY_BACKGROUNDS = Object.freeze({
  dark: "rgba(22, 24, 30, 0.60)",
  light: "rgba(255, 255, 255, 0.60)"
});
const ROLES = [
  "backgroundCanvas",
  "backgroundSurface1",
  "backgroundSurface2",
  "backgroundSurface3",
  "backgroundOverlay",
  "backgroundInput",
  "textPrimary",
  "textSecondary",
  "textMuted",
  "textDisabled",
  "textInverse",
  "borderDefault",
  "borderStrong",
  "borderFocus",
  "success",
  "warning",
  "danger",
  "information",
  "brandPrimary",
  "brandHover",
  "brandPressed",
  "textOnBrand",
  "brandSubtle"
];

const dark = {
  appearance: "dark",
  color: {
    backgroundCanvas: "#0C0C0C",
    backgroundSurface1: "#1E1E1E",
    backgroundSurface2: "#252525",
    backgroundSurface3: "#333333",
    backgroundOverlay: "rgba(0, 0, 0, 0.5)",
    backgroundInput: "#1E1E1E",
    textPrimary: "#FFFFFF",
    textSecondary: "#BDBDBD",
    textMuted: "#828282",
    textDisabled: "#828282",
    textInverse: "#FFFFFF",
    borderDefault: "#5D646C",
    borderStrong: "#FFFFFF",
    borderFocus: "#FE12A8",
    success: "#4CAF50",
    warning: "#F2994A",
    danger: "#EB5757",
    information: "#03A9F4",
    brandPrimary: "#FE12A8",
    brandHover: "#EA5DB6",
    brandPressed: "#C70D83",
    textOnBrand: "#FFFFFF",
    brandSubtle: "#FE12A81A"
  }
};
const light = {
  appearance: "light",
  color: {
    backgroundCanvas: "#F5F5F5",
    backgroundSurface1: "#FFFFFF",
    backgroundSurface2: "#E7E7E7",
    backgroundSurface3: "#D8D8D8",
    backgroundOverlay: "rgba(15, 23, 42, 0.45)",
    backgroundInput: "#FFFFFF",
    textPrimary: "#0F172A",
    textSecondary: "#475569",
    textMuted: "#64748B",
    textDisabled: "#94A3B8",
    textInverse: "#FFFFFF",
    borderDefault: "#CBD5E1",
    borderStrong: "#64748B",
    borderFocus: "#FE12A8",
    success: "#15803D",
    warning: "#B45309",
    danger: "#EB5757",
    information: "#0369A1",
    brandPrimary: "#FE12A8",
    brandHover: "#EA5DB6",
    brandPressed: "#C70D83",
    textOnBrand: "#000000",
    brandSubtle: "#FE12A81A"
  }
};

export const PRODUCT_RESOLVED_THEMES = Object.freeze({ dark: Object.freeze(dark), light: Object.freeze(light) });
const PRODUCT_RESPONSE = Object.freeze({
  config: { schemaVersion: 2 },
  effectiveConfig: { schemaVersion: 2, appearance: { default: "dark", allowed: APPEARANCES } },
  resolved: PRODUCT_RESOLVED_THEMES
});

function hasFont(value) {
  if (!value || typeof value !== "object") return false;
  return Object.keys(value).some(key => /font/i.test(key) || hasFont(value[key]));
}

function isResolved(value, appearance) {
  return (
    value?.appearance === appearance &&
    ROLES.every(role => typeof value?.color?.[role] === "string" && value.color[role].length > 0)
  );
}

export function normalizeResolvedThemeResponse(value) {
  const theme = value?.theme || value;
  const policy = theme?.effectiveConfig?.appearance;
  if (
    hasFont(theme?.config) ||
    theme?.config?.schemaVersion !== 2 ||
    !policy ||
    !APPEARANCES.includes(policy.default) ||
    !Array.isArray(policy.allowed) ||
    !policy.allowed.includes(policy.default) ||
    policy.allowed.some(value => !APPEARANCES.includes(value)) ||
    !policy.allowed.every(appearance => isResolved(theme?.resolved?.[appearance], appearance))
  )
    return PRODUCT_RESPONSE;
  return theme;
}

export function getResolvedAppearance(response, appearance) {
  const theme = normalizeResolvedThemeResponse(response);
  const selected = theme.effectiveConfig.appearance.allowed.includes(appearance)
    ? appearance
    : theme.effectiveConfig.appearance.default;
  return theme.resolved[selected];
}

export function getToolbarOverlayBackground(appearance) {
  return TOOLBAR_OVERLAY_BACKGROUNDS[appearance] || TOOLBAR_OVERLAY_BACKGROUNDS.dark;
}
